export default (params) => ({
  trigger: {
    name: 'feedback_element.view',
    params: params,
  },
  config: {
    schema: {
      sub_feature: {
        enum: [
          'ar',
          'after_order',
          'trade-in',
          'return',
          'other',
          'advice',
        ],
      },
    },
    event: {
      name: 'view_content',
      params: {
        content: null,
        index: null,
        total_indices: null,
      },
    },
    nonInt: true,
  },
});
